import { X } from "lucide-react";
import { useEffect, useRef } from "react";

export default function Modal({ open, onClose, title, subtitle, children, testid }) {
  const bodyRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") closeRef.current(); };
    window.addEventListener("keydown", h);
    // iOS-safe scroll lock: pin the body so the page can't rubber-band behind the sheet
    const scrollY = window.scrollY;
    const body = document.body;
    body.classList.add("modal-open");
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    if (bodyRef.current) bodyRef.current.scrollTop = 0;
    return () => {
      window.removeEventListener("keydown", h);
      body.classList.remove("modal-open");
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      window.scrollTo(0, scrollY);
    };
    // Intentionally depend only on `open` so parent re-renders never reset scroll position.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center isolate">
      <div className="absolute inset-0 bg-[#1A1A18]/70" onClick={() => closeRef.current()} />
      <div
        ref={bodyRef}
        data-testid={testid}
        className="relative w-full sm:max-w-lg max-h-[92dvh] overflow-y-auto overscroll-contain scroll-thin bg-[#F9F9F7] text-[var(--text)] border border-[var(--line)] shadow-2xl"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        <div className="sticky top-0 z-10 flex items-start justify-between p-6 border-b border-[var(--line)] bg-[#F9F9F7]">
          <div>
            {subtitle && <p className="label-mono text-[var(--text-2)]">{subtitle}</p>}
            <h3 className="font-serif text-2xl tracking-tight mt-1">{title}</h3>
          </div>
          <button data-testid="modal-close" onClick={() => closeRef.current()} className="p-1 hover:text-[var(--accent)] transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
